import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';
import { confirmDialog } from 'primereact/confirmdialog';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelByteRate } from 'hay-core-react';
import { ModelInputBytes } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { ModelCurrency } from 'hay-core-react';
import { ModelChips } from 'hay-core-react';
import { ModelTempo } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import Plano                       from '../../../models/Plano';
import PlanoAtivacaoEnum           from '../../../enums/PlanoAtivacaoEnum';
import PlanoEstiloNavegacaoEnum    from '../../../enums/PlanoEstiloNavegacaoEnum';
import PlanoRenovacaoNavegacaoEnum from '../../../enums/PlanoRenovacaoNavegacaoEnum';
import PlanoTipoPlanoEnum          from '../../../enums/PlanoTipoPlanoEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id:            { exibir: 'main.id',                     tipo: 'numeric', largura: '5rem', fixar: true },
    descricao:     { exibir: 'main.plano.descricao',         visivel: true, validacao: { obrigatorio: true } },
    tipoplano:     { exibir: 'main.plano.tipoplano',         visivel: true, tipo: 'enum', entidade: 'plano.tipoplano' },
    integracao:    { exibir: 'main.plano.integracao',        tipo: 'boolean' },
    padrao:        { exibir: 'main.plano.padrao',            visivel: true, tipo: 'boolean', template: 'padrao.template' },
    downstream:    { exibir: 'main.plano.downstream',        visivel: true, tipo: 'byterate', validacao: { obrigatorio: true } },
    upstream:      { exibir: 'main.plano.upstream',          visivel: true, tipo: 'byterate', validacao: { obrigatorio: true } },
    ativacao:           { exibir: 'main.plano.ativacao',           visivel: true, tipo: 'enum', entidade: 'plano.ativacao' },
    estilonavegacao:    { exibir: 'main.plano.estilonavegacao',    visivel: true, tipo: 'enum', entidade: 'plano.estilonavegacao' },
    renovacaonavegacao: { exibir: 'main.plano.renovacaonavegacao', tipo: 'enum', entidade: 'plano.renovacaonavegacao' },
    temponavegacao:     { exibir: 'main.plano.temponavegacao',     tipo: 'numeric', template: 'temponavegacao.template' },
    bytesnavegacao:     { exibir: 'main.plano.bytesnavegacao',     tipo: 'bytes' },
    exigevoucheraposexpiracao: { exibir: 'main.plano.exigevoucheraposexpiracao', tipo: 'boolean' },
    quantidadesessoes:  { exibir: 'main.plano.quantidadesessoes',  tipo: 'numeric' },
    pacoteserp:         { exibir: 'main.plano.pacoteserp',        tipo: 'json' },
    valor:              { exibir: 'main.plano.valor',             tipo: 'currency' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const booleanTemplate = (campo) => (rowData) => (
    <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);

const renderers = {
    padrao:                        { template: booleanTemplate('padrao') },
    'plano.tipoplano':             PlanoTipoPlanoEnum,
    'plano.ativacao':              PlanoAtivacaoEnum,
    'plano.estilonavegacao':       PlanoEstiloNavegacaoEnum,
    'plano.renovacaonavegacao':    PlanoRenovacaoNavegacaoEnum,
    temponavegacao: { template: (rowData) => (rowData.temponavegacao > 0 ? UtilService.formatarDuracaoCurta(rowData.temponavegacao) : '—') },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class PlanoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        const estilo = model.estilonavegacao.value?.id;
        const estiloFixa = estilo === 'main.plano.estilonavegacao.fixa';
        const estiloDinamica = estilo === 'main.plano.estilonavegacao.dinamica';
        const ativacaoVoucher = model.ativacao.value?.id === 'main.plano.ativacao.voucher';
        const integracaoAtiva = model.integracao.value === true;
        return (
            <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
                <TabPanel header={UtilService.traduzir('main.plano.aba.basica')} leftIcon="pi pi-home mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.descricao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelDropDown model={model.tipoplano} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelByteRate model={model.downstream} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelByteRate model={model.upstream} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.integracao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.padrao} contexto={contexto} />
                        </div>
                        
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.ativacao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.estilonavegacao} contexto={contexto} />
                        </div>
                        {(estiloFixa || estiloDinamica) && (
                            <div className="field col-12 md:col-4 mt-3">
                                <ModelDropDown model={model.renovacaonavegacao} contexto={contexto} />
                            </div>
                        )}
                        {(estiloFixa || estiloDinamica) && (
                            <div className="field col-12 md:col-4 mt-3">
                                <ModelTempo model={model.temponavegacao} contexto={contexto} />
                            </div>
                        )}
                        {estiloDinamica && (
                            <div className="field col-12 md:col-4 mt-3">
                                <ModelInputBytes model={model.bytesnavegacao} contexto={contexto} />
                            </div>
                        )}
                        {(estiloFixa || estiloDinamica) && (
                            <div className="field col-12 md:col-4 mt-3">
                                <ModelBoolean model={model.exigevoucheraposexpiracao} contexto={contexto} />
                            </div>
                        )}
                        {ativacaoVoucher && (
                            <div className="field col-12 md:col-4 mt-3">
                                <ModelCurrency model={model.valor} contexto={contexto} />
                            </div>
                        )}
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelInputNumber model={model.quantidadesessoes} contexto={contexto} />
                        </div>
                        {integracaoAtiva && (
                            <div className="field col-12 md:col-8 mt-3">
                                <ModelChips model={model.pacoteserp} contexto={contexto} />
                            </div>
                        )}
                    </div>
                </TabPanel>
                <TabPanel disabled={true} header={UtilService.traduzir('main.plano.aba.avancado')} leftIcon="pi pi-cog mr-2">
                    <div className="grid">
                        
                    </div>
                </TabPanel>
            </TabViewComErro>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class PlanoTemplate extends Component {

    // Processo "Sincronizar": cria/atualiza o perfil deste plano em todas as Routerboards ativas
    // da mesma publicação (ver Plano.sincronizar). Verificação de existência + set/add já é feita
    // inteiramente no backend — aqui só confirma com o usuário e exibe o resultado.
    sincronizar = () => {
        const plano = this.gridRef?.getSelected()?.[0];
        if (!plano) return;

        confirmDialog({
            message: <p>{UtilService.traduzir('main.plano.confirmacaoSincronizar.mensagem')}</p>,
            className: 'w-3',
            header: UtilService.traduzir('main.plano.confirmacaoSincronizar'),
            icon: 'pi pi-exclamation-triangle p-error',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            draggable: false,
            accept: async () => {
                const resultado = await Plano.sincronizar(plano.id);
                if (!resultado.status) {
                    const detalhe = UtilService.traduzir(resultado?.data?.state) || resultado?.data?.mensagem || '';
                    UtilService.showToast({ sticky: true, severity: 'error', summary: UtilService.traduzir('main.plano.sincronizar.erro'), detail: detalhe });
                } else if (resultado.data.total === 0) {
                    UtilService.showToast({ severity: 'warn', summary: UtilService.traduzir('main.plano.sincronizar.erro'), detail: UtilService.traduzir('main.plano.sincronizar.sememrbativa') });
                } else if (resultado.data.falhas.length === 0) {
                    UtilService.showToast({ severity: 'success', summary: UtilService.traduzir('main.plano.sincronizar.sucesso'), detail: UtilService.traduzir('main.plano.sincronizar.sucesso.detalhe') });
                } else {
                    const nomes = resultado.data.falhas.map((falha) => falha.descricao).join(', ');
                    UtilService.showToast({ sticky: true, severity: 'warn', summary: UtilService.traduzir('main.plano.sincronizar.parcial'), detail: UtilService.traduzir('main.plano.sincronizar.parcial.detalhe') + nomes });
                }
            },
        });
    }

    processos() {
        return [{
            label:    'main.duplicar',
            icon:     'pi pi-clone',
            disabled: true,
            ativo: (processo, selected) => {
                processo.disabled = selected.length !== 1;
                return processo;
            },
            command: () => { this.gridRef?.duplicar(); },
        }, {
            label:    'main.plano.sincronizar',
            icon:     'pi pi-sync',
            disabled: true,
            ativo: (processo, selected) => {
                processo.disabled = selected.length !== 1;
                return processo;
            },
            command: () => this.sincronizar(),
        }];
    }

    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={Plano}
                model={model}
                identidade="main.plano"
                permissoes={this.props.permissoes}
                icone="pi-wallet"
                storageKey="dt-planos"
                processos={this.processos()}
                renderers={renderers}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <PlanoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default PlanoTemplate;
